import { ModalDirective } from 'ng2-bootstrap/components/modal';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TranslateService } from '../../shared/translate/translate.service';
import { IKeyValueInterface } from '../../shared/config';
import { AuthService } from '../../shared/models/auth.service';
import { RoleAvailabilityModel } from '../../roleavailability/models/roleavailability.model';
import { PersonModel } from '../../person/models/person.model';
import { InvitePersonModel } from '../models/admin-to-invite.model';

@Component({
  selector: 'wego-invite-admin-popup',
  template: require('../views/invite-admin-popup.component.html'),
  providers: []
})

export class InviteAdminPopupComponent implements OnInit, OnDestroy {
  email: string;
  public availablePersons: InvitePersonModel[] = [];
  ErrorMsg: string = '';
  errorModel: IKeyValueInterface[] = [];
  _popupTitle: string = this.translate.instant('LblInvite');
  availableRoles: RoleAvailabilityModel[] = [];
  personHashId: string = "";

  @ViewChild('InviteAdminModal') public InviteAdminModal: ModalDirective;

  @Input()
  set popupTitle(popupTitle: string) {
    this._popupTitle = (popupTitle && popupTitle.trim());
  }
  get popupTitle() { return this._popupTitle; }

  @Output('onConfirm') onConfirm = new EventEmitter();
  @Output('onCancel') onCancel = new EventEmitter();
  @Output('onEmailSearch') onEmailSearch = new EventEmitter();

  constructor(private translate: TranslateService
    , private authService: AuthService) {
  }

  ngOnInit() {
  }

  public show() {
    this.ErrorMsg = "";
    this.errorModel = [];
    this.personHashId = "";
    this.email = "";
    this.availablePersons = [];
    this.InviteAdminModal.show();
  }

  public hide() {
    this.InviteAdminModal.hide();
  }

  private Confirm($event: any) {
    let selectedRoleId = this.availableRoles.filter(x => x.isChecked).map(y => y.roleHashId);
    this.onConfirm.emit({ emailAddress: this.email, personHashId: this.personHashId, roleHashIdList: selectedRoleId });
  }

  private Reject($event: any) {
    this.hide();
    this.onCancel.emit($event);
  }

  public SearchUsers() {
    this.onEmailSearch.emit({ emailAddress: this.email });
  }

  public EmailAddressChange() {
    this.personHashId = "";
    this.availablePersons = [];
  }

  ngOnDestroy() {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-invite-popup/components/invite-admin-popup.component.ts